<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
            v-model="search"
            placeholder="输入试题题目搜索"
            clearable
            @change="getTitleList">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getTitleList" class="el-icon-search" type="primary"></el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="success" icon="el-icon-upload2" :loading="importLoading"
                   @click="openImportSubjectDialog">上传题库</el-button>
        <input ref="importFileInput" class="import-file-input" type="file"
               accept=".csv,.xlsx,.docx" @change="handleImportFileSelected">
      </el-form-item>

      <el-form-item>
        <el-button type="info" plain icon="el-icon-download" @click="downloadTemplate">下载模板</el-button>
      </el-form-item>

      <el-form-item>
        <el-popconfirm title="确定批量删除?" @confirm="delHandle(null)">
          <el-button type="danger" slot="reference" :disabled="delBtlStatu" v-if="hasPermission()">删除选中</el-button>
        </el-popconfirm>
      </el-form-item>
      <el-form-item>
        <template>
          <el-select v-model="subject" clearable placeholder="按学科分类" @change="getTitleList">
            <el-option
                v-for="item in subject_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item>
        <template>
          <el-select v-model="title_type" clearable placeholder="按题型分类" @change="getTitleList">
            <el-option
                v-for="item in title_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
    </el-form>

    <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        stripe
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="40">
      </el-table-column>
      <el-table-column
          prop="id"
          label="id"
          width="70">
      </el-table-column>
      <el-table-column
          prop="theme"
          label="题干"
          width="500">
        <template slot-scope="scope">
          <p v-html="(scope.row.theme).slice(0, 38) + '...'"></p>
        </template>
      </el-table-column>
      <el-table-column
          prop="subject_name"
          label="学科"
          width="90">
      </el-table-column>
      <el-table-column
          prop="type_name"
          label="题型"
          width="80">
      </el-table-column>
      <el-table-column
          prop="title_score"
          label="分数"
          width="80">
      </el-table-column>
      <el-table-column
          prop="time"
          label="创编时间"
          width="170">
      </el-table-column>

      <el-table-column
          prop="icon"
          label="操作">
        <template slot-scope="scope">
          <el-button @click="editHandle(scope.row.id, scope.row.title_type)" size="mini">编辑</el-button>
          <el-button @click="showQuestion(scope.row.id)" size="mini">预览</el-button>
          <span>&nbsp;&nbsp;</span>
          <template>
            <el-popconfirm title="确定删除?" @confirm="delHandle(scope.row.id)">
              <el-button type="danger" slot="reference" v-if="hasPermission()" size="mini">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="current"
        :page-size="size"
        :total="total">
    </el-pagination>
    <el-dialog :visible.sync="questionShow.dialog" style="width: 100%;height: 100%">
      <ShowTitle :qType="questionShow.qType" :question="questionShow.question" :qLoading="questionShow.loading"/>
    </el-dialog>
    <el-dialog title="选择题库导入学科" :visible.sync="importSubjectDialog" width="520px"
               :close-on-click-modal="false" @closed="handleImportSubjectDialogClosed">
      <el-alert title="请先确定题目所属学科，确认后才能选择并上传题库文件。" type="info"
                show-icon :closable="false"></el-alert>
      <el-form label-position="top" class="import-subject-form">
        <el-form-item label="导入方式" required>
          <el-radio-group v-model="importSubjectMode" @change="handleImportSubjectModeChange">
            <el-radio label="existing">选择已有学科</el-radio>
            <el-radio label="new">新增学科并命名</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="importSubjectMode === 'existing'" label="选择已有学科" required>
          <el-select v-model="importSubjectId" clearable filterable placeholder="请选择导入目标学科"
                     class="import-subject-select">
            <el-option v-for="item in subject_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else label="新学科名称" required>
          <el-input v-model="newImportSubjectName" clearable maxlength="128" show-word-limit
                    placeholder="请输入新学科名称" class="import-subject-name"
                    @keyup.enter.native="confirmImportSubjectSelection"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importSubjectDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmImportSubjectSelection">下一步：选择题库文件</el-button>
      </span>
    </el-dialog>
    <el-dialog title="题库导入预览" :visible.sync="importBatch.dialog" width="92%"
               :before-close="closeImportPreview" :close-on-click-modal="false">
      <el-alert title="当前仅为解析预览，点击“确认写入题库”前不会新增任何题目。" type="warning"
                show-icon :closable="false"></el-alert>
      <div class="import-summary">
        <el-tag>批次：{{ importBatch.batchId }}</el-tag>
        <el-tag type="info">状态：{{ importBatch.status }}</el-tag>
        <el-tag>
          导入学科：{{ importBatch.subjectName || '未识别' }}
          （{{ importBatch.subjectMode === 'new' ? '新增' : '已有' }}）
        </el-tag>
        <el-tag type="success">可导入 {{ importBatch.ready }}</el-tag>
        <el-tag type="warning">重复/冲突 {{ importBatch.conflicts }}</el-tag>
        <el-tag type="danger">错误 {{ importBatch.failed }}</el-tag>
      </div>
      <el-table :data="importBatch.items" border size="mini" max-height="560" row-key="row">
        <el-table-column width="48">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.include"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="row" label="行" width="55"></el-table-column>
        <el-table-column label="状态" width="105">
          <template slot-scope="scope">
            <el-tag size="mini" :type="importStatusType(scope.row.status)">{{ importStatusText(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="学科" min-width="145">
          <template slot-scope="scope">
            <el-input v-model="scope.row.subject_name" size="mini" @input="markImportItemEdited(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="题型" width="115">
          <template slot-scope="scope">
            <el-select v-model="scope.row.title_type" size="mini" @change="markImportItemEdited(scope.row)">
              <el-option v-for="type in title_type_list" :key="type.id" :label="type.name" :value="type.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="题干" min-width="280">
          <template slot-scope="scope">
            <el-input v-model="scope.row.theme" type="textarea" :rows="2" @input="markImportItemEdited(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="答案" min-width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.right_answer" type="textarea" :rows="2" @input="markImportItemEdited(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="分数" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.title_score" size="mini" @input="markImportItemEdited(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="52">
          <template slot-scope="scope">
            <div v-if="scope.row.errors && scope.row.errors.length" class="import-error">
              错误：{{ scope.row.errors.join('；') }}
            </div>
            <div v-for="conflict in scope.row.conflicts || []" :key="conflict.message" class="import-conflict">
              冲突：{{ conflict.message }}<span v-if="conflict.title_ids">（题目 ID：{{ conflict.title_ids.join(', ') }}）</span>
            </div>
            <div v-if="scope.row.title_type === 0 || scope.row.title_type === 1" class="import-options">
              <div v-for="option in scope.row.options" :key="option.prefix" class="import-option-row">
                <strong>{{ option.prefix }}</strong>
                <el-input v-model="option.content" size="mini" @input="markImportItemEdited(scope.row)"></el-input>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelImportBatch">取消导入</el-button>
        <el-button type="primary" :loading="importConfirmLoading" @click="confirmImportBatch"
                   :disabled="!importBatch.items.some(item => item.include)">确认写入题库</el-button>
      </span>
    </el-dialog>
    <!--    一直维护好ueditor-->
    <Ueditor v-show="false"></Ueditor>
    <div class="app-footer">© 海之林科技 在线考试系统</div>
  </div>
</template>

<script>
import ShowTitle from "../../components/ShowTitle";
import Ueditor from '@/components/Ueditor'
import {normalizePageData} from '@/utils/pageData'

export default {
  name: "TitleList",
  components: {ShowTitle, Ueditor},
  data() {
    return {
      questionShow: {
        qType: 0,
        dialog: false,
        question: {},
        loading: false
      },
      title_type: null,
      subject: null,
      importSubjectMode: 'existing',
      importSubjectId: null,
      newImportSubjectName: '',
      importSubjectDialog: false,
      importFileSelectionPending: false,
      title_type_list: [
        {id: 0, name: '单选题'},
        {id: 1, name: '多选题'},
        {id: 2, name: '判断题'},
        {id: 3, name: '简答题'},
      ],
      search: '',
      delBtlStatu: true,
      total: 0,
      size: 10,
      current: 1,
      subject_list: [],
      tableData: [],
      multipleSelection: [],
      importLoading: false,
      importConfirmLoading: false,
      importBatch: {
        dialog: false,
        batchId: '',
        status: '',
        total: 0,
        ready: 0,
        conflicts: 0,
        failed: 0,
        subjectMode: '',
        subjectId: null,
        subjectName: '',
        items: []
      },
    }
  },
  created() {
    this.getTitleList()
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length === 0
    },
    handleSizeChange(val) {
      this.size = val
      this.getTitleList()
    },
    handleCurrentChange(val) {
      this.current = val
      this.getTitleList()
    },
    resetForm() {
      this.dialogVisible = false
      this.editForm = {}
    },
    handleClose() {
      this.resetForm()
    },
    getTitleList() {
      this.$http({
        url: this.$settings.BASE_URL + '/paper/title_list/',
        method: 'get',
        params: {
          page: this.current,
          size: this.size,
          search: this.search,
          title_type: this.title_type,
          subject: this.subject,
        },
      }).then(res => {
        if (res.data.code === 20000) {
          const pageData = normalizePageData(res.data)
          this.tableData = pageData.rows
          this.total = pageData.count
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg,
            duration: 3000,
          })
        }
      })
      this.$http({
        url: this.$settings.BASE_URL + '/paper/subject_list/',
        method: 'get',
      }).then(res => {
        this.subject_list = normalizePageData(res.data).rows
      })
    },
    editHandle(id, titleType) {
      if (titleType === 3) {
        this.$router.push(`/teacher/ShortAnswer/?id=${id}`)
      } else if (titleType === 2) {
        this.$router.push(`/teacher/JudgeTitle/?id=${id}`)
      } else if (titleType === 0) {
        this.$router.push(`/teacher/SingleChoice/?id=${id}`)
      } else if (titleType === 1) {
        this.$router.push(`/teacher/MultiChoice/?id=${id}`)
      }
    },
    delHandle(id) {
      let ids = []
      if (id) {
        ids.push(id)
      } else {
        this.multipleSelection.forEach(row => {
          ids.push(row.id)
        })
      }
      console.log(ids)
      this.$http({
        url: this.$settings.BASE_URL + '/paper/title_edit/del_title/',
        method: 'post',
        data: ids,
      }).then(res => {
        if (res.data.code === 20000) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'success',
          });
          this.getTitleList()
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            duration: 3000,
          })
        }
      })
    },
    showQuestion(id) {
      this.questionShow.dialog = true
      this.questionShow.loading = true
      this.$http({
        url: this.$settings.BASE_URL + `/paper/title_list/${id}`,
        method: 'get',
      }).then(res => {
        this.questionShow.qType = res.data.result.title_type
        this.questionShow.question = res.data.result
        this.questionShow.loading = false
      })
    },
    handleImportSubjectModeChange(mode) {
      if (mode === 'existing') {
        this.newImportSubjectName = ''
      } else {
        this.importSubjectId = null
      }
    },
    openImportSubjectDialog() {
      if (this.importLoading) {
        return
      }
      this.importFileSelectionPending = false
      this.importSubjectDialog = true
    },
    confirmImportSubjectSelection() {
      if (!this.validateImportSubject()) {
        return
      }
      this.importFileSelectionPending = true
      this.importSubjectDialog = false
    },
    handleImportSubjectDialogClosed() {
      if (!this.importFileSelectionPending) {
        return
      }
      this.importFileSelectionPending = false
      this.$nextTick(() => {
        const input = this.$refs.importFileInput
        if (!input) {
          this.$message.error('文件选择器初始化失败，请刷新页面后重试')
          return
        }
        input.value = ''
        input.click()
      })
    },
    handleImportFileSelected(event) {
      const input = event && event.target
      const file = input && input.files ? input.files[0] : null
      if (!file) {
        return
      }
      if (!this.beforeImportUpload(file)) {
        input.value = ''
        return
      }
      this.uploadQuestionBank({file})
      input.value = ''
    },
    normalizedNewImportSubjectName() {
      return (this.newImportSubjectName || '').trim()
    },
    validateImportSubject(showMessage = true) {
      let message = ''
      if (this.importSubjectMode === 'existing') {
        if (!this.importSubjectId) {
          message = '请选择要导入的已有学科'
        }
      } else if (this.importSubjectMode === 'new') {
        const name = this.normalizedNewImportSubjectName()
        if (!name) {
          message = '请输入新学科名称，不能只包含空格'
        } else if (this.subject_list.some(item => (item.name || '').trim().toLowerCase() === name.toLowerCase())) {
          message = '该学科名称已存在，请改为“选择已有学科”'
        }
      } else {
        message = '请选择导入学科方式'
      }
      if (message && showMessage) {
        this.$message.error(message)
      }
      return !message
    },
    appendImportSubjectContract(target) {
      target.subject_mode = this.importSubjectMode
      if (this.importSubjectMode === 'existing') {
        target.subject_id = this.importSubjectId
        delete target.new_subject_name
      } else {
        target.new_subject_name = this.normalizedNewImportSubjectName()
        delete target.subject_id
      }
      return target
    },
    beforeImportUpload(file) {
      const allow = ['csv', 'xlsx', 'docx']
      const ext = (file.name.split('.').pop() || '').toLowerCase()
      const validType = allow.includes(ext)
      const validSize = file.size / 1024 / 1024 <= 10
      if (!validType) {
        this.$message.error('只支持 CSV、XLSX 或 DOCX 文件')
        return false
      }
      if (!validSize) {
        this.$message.error('题库文件不能超过 10MB')
        return false
      }
      return true
    },
    uploadQuestionBank(option) {
      if (!this.validateImportSubject()) {
        if (option && typeof option.onError === 'function') {
          option.onError(new Error('导入学科校验失败'))
        }
        return
      }
      const formData = new FormData()
      formData.append('file', option.file)
      formData.append('action', 'preview')
      const subjectContract = this.appendImportSubjectContract({})
      Object.keys(subjectContract).forEach(key => {
        formData.append(key, subjectContract[key])
      })
      this.importLoading = true
      this.$http({
        url: this.$settings.BASE_URL + '/paper/title_list/import_bank/',
        method: 'post',
        data: formData,
        timeout: 180000,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }).then(res => {
        if (res.data.code === 20000) {
          const result = res.data.result || {}
          this.importBatch = {
            dialog: true,
            batchId: result.batch_id || '',
            status: result.status || 'previewed',
            total: result.total || 0,
            ready: result.ready || 0,
            conflicts: result.conflicts || 0,
            failed: result.failed || 0,
            subjectMode: result.subject_mode || this.importSubjectMode,
            subjectId: result.subject_id || this.importSubjectId,
            subjectName: result.subject_name || (this.importSubjectMode === 'new'
              ? this.normalizedNewImportSubjectName()
              : this.importSubjectNameById(this.importSubjectId)),
            items: result.items || []
          }
          this.$message.success(`解析完成，共 ${this.importBatch.total} 道，请检查后确认`)
        } else {
          this.$message.error(res.data.msg || '导入失败')
        }
      }).catch(error => {
        const responseMessage = error && error.response && error.response.data
          ? error.response.data.msg
          : ''
        this.$message.error(responseMessage || '导入失败，请检查文件格式或服务器日志')
      }).finally(() => {
        this.importLoading = false
      })
    },
    importStatusType(status) {
      return status === 'ready' ? 'success' : (status === 'conflict' ? 'warning' : 'danger')
    },
    importStatusText(status) {
      return status === 'ready' ? '可导入' : (status === 'conflict' ? '重复/冲突' : '有错误')
    },
    markImportItemEdited(item) {
      item.status = 'ready'
      item.errors = []
      item.conflicts = []
      this.refreshImportSummary()
    },
    refreshImportSummary() {
      this.importBatch.ready = this.importBatch.items.filter(item => item.status === 'ready').length
      this.importBatch.conflicts = this.importBatch.items.filter(item => item.status === 'conflict').length
      this.importBatch.failed = this.importBatch.items.filter(item => item.status === 'error').length
    },
    importSubjectNameById(subjectId) {
      const subject = this.subject_list.find(item => String(item.id) === String(subjectId))
      return subject ? subject.name : ''
    },
    applyImportBatchResult(result) {
      this.importBatch.status = result.status || this.importBatch.status
      this.importBatch.total = result.total || 0
      this.importBatch.ready = result.ready || 0
      this.importBatch.conflicts = result.conflicts || 0
      this.importBatch.failed = result.failed || 0
      this.importBatch.subjectMode = result.subject_mode || this.importBatch.subjectMode
      this.importBatch.subjectId = result.subject_id || this.importBatch.subjectId
      this.importBatch.subjectName = result.subject_name || this.importBatch.subjectName
      if (Array.isArray(result.items)) {
        this.importBatch.items = result.items
      }
    },
    confirmImportBatch() {
      if (!this.importBatch.batchId) {
        this.$message.error('导入批次不完整，请重新选择文件预览')
        return
      }
      const confirmData = {
        action: 'confirm',
        batch_id: this.importBatch.batchId,
        subject_mode: this.importBatch.subjectMode,
        items: this.importBatch.items,
      }
      if (this.importBatch.subjectMode === 'existing') {
        confirmData.subject_id = this.importBatch.subjectId
      } else {
        confirmData.new_subject_name = this.importBatch.subjectName
      }
      this.importConfirmLoading = true
      this.$http({
        url: this.$settings.BASE_URL + '/paper/title_list/import_bank/',
        method: 'post',
        data: confirmData,
      }).then(res => {
        const result = res.data.result || {}
        this.applyImportBatchResult(result)
        if (res.data.code === 20000 && result.status === 'confirmed') {
          this.$message.success(`已确认导入 ${result.created || 0} 道题目`)
          this.importBatch.dialog = false
          this.getTitleList()
        } else {
          this.$message.error(res.data.msg || '仍有错误或冲突，未写入题库')
        }
      }).catch(error => {
        this.applyConfirmFailure(error)
      }).finally(() => {
        this.importConfirmLoading = false
      })
    },
    applyConfirmFailure(error) {
      let message = error && error.response && error.response.data ? error.response.data.msg : ''
      let details = null
      if (message) {
        try {
          details = JSON.parse(message)
        } catch (e) {
          details = null
        }
      }
      if (details && Array.isArray(details.items)) {
        details.items.forEach(failure => {
          const item = this.importBatch.items.find(row => row.row === failure.row)
          if (item) {
            item.status = failure.conflicts && failure.conflicts.length ? 'conflict' : 'error'
            item.errors = failure.errors || []
            item.conflicts = failure.conflicts || []
          }
        })
        this.refreshImportSummary()
        this.$message.error(details.message || '仍有错误或冲突，整批未写入')
        return
      }
      this.$message.error(message || '确认失败，未写入题库')
    },
    cancelImportBatch() {
      this.closeImportPreview(() => {
        this.importBatch.dialog = false
      })
    },
    closeImportPreview(done) {
      if (!this.importBatch.batchId || this.importBatch.status !== 'previewed') {
        done()
        return
      }
      this.$http({
        url: this.$settings.BASE_URL + '/paper/title_list/import_bank/',
        method: 'post',
        silentError: true,
        data: {action: 'cancel', batch_id: this.importBatch.batchId},
      }).then(() => {
        this.importBatch.status = 'cancelled'
        this.$message.info('已取消，未写入题库')
        done()
      }).catch(() => {
        this.$message.warning('取消请求未确认；预览批次不会自动写入题库')
        done()
      })
    },
    downloadTemplate() {
      const rows = [
        ['学科', '题型', '题干', 'A', 'B', 'C', 'D', 'E', 'F', '正确答案', '分数'],
        ['PVB609/SCB502 产品知识', '单选题', '单选题示例：以下哪项正确？', '选项A', '选项B', '选项C', '选项D', '', '', 'A', '5'],
        ['PVB609/SCB502 产品知识', '多选题', '多选题示例：以下哪些正确？', '选项A', '选项B', '选项C', '选项D', '选项E', '', 'AC', '6'],
        ['PVB609/SCB502 产品知识', '判断题', '判断题示例：该说法正确。', '', '', '', '', '', '', '正确', '4'],
        ['PVB609/SCB502 产品知识', '简答题', '简答题示例：请简述处理流程。', '', '', '', '', '', '', '参考答案可为空', '10']
      ]
      const csv = '\ufeff' + rows.map(row => row.map(this.escapeCsvCell).join(',')).join('\n')
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '题库导入模板.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
    escapeCsvCell(value) {
      const text = String(value)
      if (/[",\n]/.test(text)) {
        return `"${text.replace(/"/g, '""')}"`
      }
      return text
    },
  }
}
</script>

<style scoped>

.import-subject-select {
  width: 100%;
}

.import-subject-name {
  width: 100%;
}

.import-file-input {
  display: none;
}

.import-subject-form {
  margin-top: 18px;
}

.import-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0;
}

.import-error {
  margin-bottom: 8px;
  color: #f56c6c;
}

.import-conflict {
  margin-bottom: 8px;
  color: #e6a23c;
}

.import-options {
  max-width: 760px;
}

.import-option-row {
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

</style>
